import { unwrapResult } from "@reduxjs/toolkit";
import { Col, Modal, Row, Table } from "antd";
import React, { useContext, useEffect, useState } from "react";
import { useAppDispatch } from "../../app/hooks";
import { ThemeContext } from "../../theme/theme";
import { getWarningRuleDetailAsync } from "./warningRuleSlice";

export const WarningRuleDetailModal = (props: {
  crId?: any;
  visible: boolean;
  onOk: () => void;
  onCancel: () => void;
}) => {
  const dispatch = useAppDispatch();

  const theme = useContext(ThemeContext);

  const [detail, setDetail] = useState<any>();

  const [list, setList] = useState<any>();

  const [TableList, setTableList] = useState<any>();

  useEffect(() => {
    if (props.crId) {
      dispatch(getWarningRuleDetailAsync(props.crId))
        .then(unwrapResult)
        .then((d: any) => {
          setDetail(d);
          setList(d.orgSupervises);
          setTableList(d.sonRule);
        })
        .catch(() => {
          // do nothing
        });
    } else {
      setDetail(undefined);
    }
  }, [dispatch, props.crId]);

  const labelStyle = {
    flex: "8rem",
    style: {
      color: theme.tc3,
      fontSize: "1rem",
      textAlign: "right",
      marginBottom: 10,
    } as React.CSSProperties,
  };

  const valueStyle = {
    flex: 1,
    style: {
      color: theme.tc1,
      fontSize: "1rem",
      marginBottom: 4,
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
    } as React.CSSProperties,
  };

  return (
    <>
      <Modal
        width={1100}
        title='预警规则详情'
        footer={null}
        visible={props.visible}
        onOk={() => {
          props.onOk()
        }}
        onCancel={() => {
          props.onCancel()
        }}
      >
        <Row gutter={20}>
          <Col span={12}>
            <Row>
              <Col {...labelStyle}>主规则名称：</Col>
              <Col {...valueStyle}>{detail?.mainName}</Col>
            </Row>
          </Col>
          <Col span={12}>
            <Row>
              <Col {...labelStyle}>规则分类：</Col>
              <Col {...valueStyle}>
                {detail?.type === 0
                  ? '基础类'
                  : detail?.type === 1
                  ? '个性类'
                  : ''}
              </Col>
            </Row>
          </Col>
        </Row>
        <Row gutter={20}>
          <Col span={20}>
            <Row>
              <Col {...labelStyle}>开通卫健委(局)：</Col>
              {list?.map((a: any) => {
                return (
                  <Col
                    span={24}
                    style={{
                      background: 'white',
                      color: theme.tc1,
                      fontSize: '1rem',
                      marginBottom: 4,
                      marginLeft: '130px',
                      position: 'relative',
                      top: '-34px',
                    }}
                  >
                    {a}
                  </Col>
                )
              })}
            </Row>
          </Col>
        </Row>
        <Table
          style={{ width: '1100px' }}
          pagination={false}
          size='small'
          bordered
          dataSource={TableList}
          rowKey={(t: any) => t.id}
          columns={[
            {
              title: '序号',
              dataIndex: 'no',
              align: 'center',
              key: 'no',
              width: '4rem',
              render: (_1, _2, i) => `${i + 1}`,
            },
            {
              title: '规则编号',
              key: 'ruleCode',
              dataIndex: 'ruleCode',
              width: '5rem',
              align: 'center',
            },
            {
              title: '子项编码',
              dataIndex: 'subCode',
              align: 'center',
              width: '5rem',
              key: 'subCode',
            },
            {
              title: '子项名称',
              dataIndex: 'subName',
              align: 'center',
              key: 'subName',
              render: (_, r) => {
                return (
                  <i
                    style={{
                      fontStyle: 'normal',
                      overflow: 'hidden',
                      whiteSpace: 'normal',
                    }}
                  >
                    {r.subName}
                  </i>
                )
              },
            },
          ]}
        ></Table>
      </Modal>
    </>
  )
};
